import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UserService} from '../../../services/user.service';
import {empresa} from '../../../models/empresa';
import {user} from '../../../models/user';
import {proyecto} from '../../../models/proyecto';
import {Localiser} from "../../../services/localiser";

@Component({
  selector: 'app-new-user',
  templateUrl: './new-user.component.html',
  styleUrls: ['./new-user.component.css']
})
export class NewUserComponent implements OnInit {

  nombre: string = "";
  apellidos: string = "";
  email: string = "";
  telefono: string = "";
  idPermiso: string = "Ateneo";
  licenseExpiryDate: string = "";

  usuario: user;
  proyectos: proyecto[];
  selectProyectos: boolean = false;

  charging: boolean = false;
  feedback: number = 0;

  constructor(public dialogRef: MatDialogRef<NewUserComponent>, @Inject(MAT_DIALOG_DATA) public data: {empresa: empresa},
              private userService: UserService, public localiser: Localiser) { }

  ngOnInit(): void {
    this.selectProyectos = false;
  }

  newUser() {
    this.feedback = 0;
    this.charging = true;
    let usuarioRequest: user = {
      idUsuario: "ID",
      idEmpresa: this.data.empresa.idEmpresa,
      idProyectoSeleccionado: null,
      nombre: this.nombre,
      apellidos: this.apellidos,
      email: this.email,
      telefono: this.telefono,
      idPermiso: this.idPermiso,
      licenseExpiryDate: this.licenseExpiryDate,
      idContacto: "0",
      proyectos: []
    }
    this.userService.new(usuarioRequest).subscribe(result => {
      this.charging = false;
      console.log(result)
      this.usuario = <user>JSON.parse(result);
      this.selectProyectos = true;
    }, error => {
      this.charging = false;
      console.log("error.error")
      console.log(error.error)
      this.feedback = error.error;
      console.log(this.feedback)
    });
  }

  change(idProyecto, check) {
    this.userService.changeProyecto(this.usuario.idUsuario, idProyecto, check);
  }

  whichMessage() {
    if (this.feedback == -1) {
      return this.localiser.get("newUser.emailAlreadyRegistered");
    } else if (this.feedback == -2) {
      return this.localiser.get("newUser.emailBadFormat");
    }
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

}
